export let sizeWithGigabyteAbbreviationText = "KdCG1b";
export let sizeWithMegabyteAbbreviationText = "I3Depd";
export let sizeWithKilobyteAbbreviationText = "z7jo";
export let sizeWithByteAbbreviationText = "eze7xc";
export default {sizeWithGigabyteAbbreviationText,sizeWithMegabyteAbbreviationText,sizeWithKilobyteAbbreviationText,sizeWithByteAbbreviationText};